import { render } from "./TotalAccountsReceivable.vue?vue&type=template&id=47b81e22"
import script from "./TotalAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./TotalAccountsReceivable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__